module.exports = __webpack_public_path__ + "img/13.376405c7.png";